import React, { useState } from "react";
import {
  Drawer,
  Form,
  Button,
  Input,
  InputNumber,
  Switch,
  message,
} from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { API, Headers } from "../../Config";
import axios from "axios";
var width = window.innerWidth;
var innerwidth = window.innerWidth <= 760;
function FormModal(props) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    let obj = {
      name: values.name.toUpperCase(),
      value: Number(values.value),
      vat_percentage: Number(values.vat_percentage),
      rate_per_kg: Number(values.rate_per_kg),
      active: values.active,
      acc_no: "",
    };
    let URL =
      props.mode === "post"
        ? API.SERVICE_TYPE_ACTIONS
        : API.SERVICE_TYPE_ACTIONS + props.item.id;
    axios({
      method: props.mode,
      url: API.BASR_URL + URL,
      headers: Headers(),
      data: obj,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onchange();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  return (
    <Drawer
      placement={props.mode === "post" ? "center" : "left"}
      title={
        <span className="txt4">
          {props.mode === "post" ? "New" : "Update"} Service Type
        </span>
      }
      width={innerwidth ? width : width / 2.7}
      onClose={() => props.onClose()}
      visible={props.visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        layout="vertical"
        hideRequiredMark
        onFinish={onFinish}
        initialValues={{
          name: props.item && props.item.name,
          value: props.item && props.item.value,
          vat_percentage: props.item && props.item.vat_percentage,
          rate_per_kg: props.item && props.item.rate_per_kg,
          active: props.item && props.item.active ? props.item.active : false,
        }}
      >
        <Container>
          <Row>
            <Col sm="6" xs="12">
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "required" }]}
              >
                <Input
                  placeholder="Enter Name"
                  style={{ textTransform: "uppercase" }}
                />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="value"
                label="value"
                rules={[{ required: true, message: "required" }]}
              >
                <InputNumber
                  placeholder="Enter value"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="vat_percentage"
                label="VAT %"
                rules={[{ required: true, message: "required" }]}
              >
                <InputNumber
                  placeholder="Enter value"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="rate_per_kg"
                label="Rate / Kg"
                rules={[{ required: true, message: "required" }]}
              >
                <InputNumber
                  placeholder="Enter value"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                label="Active"
                name="active"
                rules={[{ required: true, message: "required" }]}
                valuePropName={props.item.active ? "checked" : "uncheked"}
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {props.mode === "post" ? null : <Col sm="6" xs="12"></Col>}
            <Col sm="6" xs="12">
              <Row>
                <Col sm="6" xs="12">
                  <Button onClick={() => props.onClose()} block>
                    Cancel
                  </Button>
                </Col>
                <Col sm="6" xs="12">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Form>
    </Drawer>
  );
}
export default FormModal;
